import React from "react";
import Accordion from "~/components/utils/Accordion";
import { useTranslation } from "react-i18next";
import ChatHistoryGraph from "~/components/ChatHistoryGraph";

const ChatHistoryGraphSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Accordion
      items={[
        {
          title: t("chatHistoryStatistics"),
          content: <ChatHistoryGraph />,
          dynamicHeight: true,
          autoHeight: true,
        },
      ]}
    />
  );
};

export default ChatHistoryGraphSection;
